import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(
  (theme) => ({
    root: {
      position: 'relative',

      '&$loading': {
        '& $label': {
          color: 'transparent',
        },

        '& $spinner': {
          opacity: '1',
        },
      },
    },
    loading: {},
    label: {},
    spinner: {
      position: 'absolute',
      opacity: '0',

      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shortest,
      }),
    },
  }),
  { name: 'Button' }
);
